// extracted by mini-css-extract-plugin
export default {"copyButton":"generated-link-dialog__copyButton___uYACT","link":"generated-link-dialog__link___IcxH4"};